import { useQuery } from '@tanstack/react-query';
import { usePharmacyStore } from '../../stores/pharmacyStore';
import patientService from '../../services/patientService';
import { parseCompositePatientId } from '../../utils/patientUtils';

export interface PatientBasicInfo {
  patient: any;
  compositeId: string;
  pharmacyId: string;
  patientNumber: string;
}

/**
 * Parse patient ID to extract pharmacy ID and patient number
 * @deprecated Use parseCompositePatientId from utils/patientUtils instead
 */
export function parsePatientId(patientId: string | undefined, activePharmacyId?: string) {
  return parseCompositePatientId(patientId, activePharmacyId);
}

/**
 * Hook to fetch basic patient info from MQTT/Kroll
 * This is always enabled as it's needed for the patient header
 */
export function usePatientBasicInfo(patientId: string | undefined) {
  const activePharmacy = usePharmacyStore((state) => state.activePharmacy);
  const { pharmacyId, patientNumber, compositeId } = parsePatientId(patientId, activePharmacy?.id);

  return useQuery({
    queryKey: ['patient', 'basic-info', compositeId],
    queryFn: async (): Promise<PatientBasicInfo> => {
      if (!pharmacyId || !patientNumber) {
        throw new Error('Invalid patient ID or missing pharmacy context');
      }

      const patientData = await patientService.getPatientFromMQTT(pharmacyId, patientNumber);

      return {
        patient: {
          ...patientData,
          compositeId,
          pharmacyId,
          patientNumber
        },
        compositeId: compositeId!,
        pharmacyId,
        patientNumber
      };
    },
    enabled: !!pharmacyId && !!patientNumber,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
